import {
    IInvoicePreview,
    IInvoiceLineAdd,
    IDriverLoadInvoiceDetails,
} from '../../../../../../api/shipment/interfaces/IInvoicePreview';

export const INVOICE_LINE_ADD: IInvoiceLineAdd = {
    itemRef: {
        listID: null,
        fullName: '',
    },
    quantity: 0,
    description: '',
    rate: null,
    amount: null,
    isPreviousInvoiceLineMatching: false,
};

export const DRIVERLOAD_INVOICE_DETAILS: IDriverLoadInvoiceDetails = {
    invoiceLineAdd: [INVOICE_LINE_ADD],
    truck: null,
    contractPO: '',
    order: '',
    invoiceNumber: '',
    totalAmount: 0,
    driverLoadId: 0,
};

export const INVOICE_PREVIEW_INITIAL_STATE: IInvoicePreview = {
    shipmentId: undefined,
    customerRef: {
        listId: null,
        fullName: '',
    },
    templateRef: {
        listId: null,
        fullName: '',
    },
    driverLoadInvoiceDetails: [DRIVERLOAD_INVOICE_DETAILS],
    txnDate: '',
    dueDate: null,
    termsRef: {
        listId: null,
        fullName: '',
    },
    lumpSumInvoiceNumber: null,
    lumpSumTotalAmount: 0,
};
